import React, { Component } from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios, { CancelToken } from 'axios';
import BetResultMatrix from '../BetResultMatrix/BetResultMatrix';
import BetResultLegendTable from '../BetResultLegendTable/BetResultLegendTable';
import BetResultAggregatesTable from '../BetResultAggregatesTable/BetResultAggregatesTable';
import './SeePositions.css';

export default class SeePositions extends Component {
  constructor(props) {
    super(props);

    this.cancellers = [];
    this.state = {
      grid: null,
      legend: null,
      isLoading: false,
      isModalOpen: false,
    };
  }

  componentWillUnmount() {
    this.cancellers.forEach(c => c.cancel());
  }

  getNewCancelToken() {
    const canceller = CancelToken.source();
    this.cancellers.push(canceller);

    return canceller.token;
  }

  fetchData() {
    this.setState({ isLoading: true });

    axios.post('positions', this.props.trades, { cancelToken: this.getNewCancelToken() })
      .then(({ data }) => {
        this.setState({
          isModalOpen: true,
          grid: data.grid,
          legend: data.legend,
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  renderModal() {
    const { isModalOpen, grid, legend } = this.state;
    const { event } = this.props;
    if (!isModalOpen) return null;
    const isFootball = ['fb', 'fb_ht'].includes(event.sport);

    return (
      <Modal
        bsSize="lg"
        dialogClassName="bets-overview__modal"
        show={isModalOpen}
        onHide={() => this.setState({ isModalOpen: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title className="SeePositions__modal-title">
            <strong className="competition">{event.competition_name}</strong>
            <strong>{event.home_team}</strong>
            <i>vs</i>
            <strong>{event.away_team}</strong>
            <span className="time nowrap">
              {/* <FontAwesomeIcon icon="clock" className="ml-1 mr text-pale" /> */}
              {moment(event.start_time).format('HH:mm')}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isFootball ? <BetResultMatrix data={grid} /> : null}

          {!isFootball ? <BetResultAggregatesTable data={legend} /> : null}

          <BetResultLegendTable data={legend} />
        </Modal.Body>
      </Modal>
    );
  }

  renderButtonLabel() {
    const { isLoading } = this.state;

    if (isLoading) return <FontAwesomeIcon icon="circle-notch" spin className="refresh-icon" />;

    return (
      <div>
        <FontAwesomeIcon icon="list-ol" className="mobile" />
        <span className="desktop">
          See positions
        </span>
      </div>
    );
  }

  render() {
    const { isLoading } = this.state;

    return (
      <button
        className="SeePositions btn btn-default"
        onClick={() => this.fetchData()}
        disabled={isLoading}
      >
        {this.renderButtonLabel()}

        {this.renderModal()}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SeePositions/SeePositions.js